import React from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import AddRounded from '@material-ui/icons/AddRounded';
import { Collapse } from '@material-ui/core';

import Component from '../../../ui-components/Component';
import OYOCard from './components/OYOCard';
import OyoAddCard from './components/OYOCard/add';
import { withTranslations, withResizer } from '../../../HoCs';
import Page from '../../../ui-components/Page';
import NoProperty from '../../../resources/vectors/no_property';
import styles from './styles';
import { merge, isEmptyList } from '../../../utils';
import { MENU_WIDTH, centerAbs, columnCenter } from '../../../resources/styles';
import view from '../../../Enums';
import { fetchProperties } from './interactor';
import { handleNetworkError, GrowTransition } from '../../../ui-components/utils';
import Popup from './components/Popup';

import { Link } from 'react-router-dom';
import pages, { getRouteForPage } from '../../../PageEnums';

import Carousel from '../../../ui-components/Carousel';
import Property from '../../../resources/vectors/property';
import LineLoader from '../../../ui-components/Loader/Line';
import CyclicFooter from '../../../ui-components/Banners/CyclicFooter';
import { hmsSelfOnboardingEnabled } from '../../../config/countryConfig';
import { forceLogout } from '../../../services/Network';


class PropertyListing extends Component {

    styles = styles;
    translation_key = 'properties_translations';
    state = {
        loading: false,
        error: false,
        properties: [],
        createDialog: false,
    };

    componentDidMount = () => {
        hmsSelfOnboardingEnabled() ? forceLogout() :
        this.indexCall(() => {
        if (isEmptyList(this.state.properties)) this.toggleCreateDialog(true)()
    });
    }

    indexCall = callback => this.setState({ loading: true, error: false }, () => fetchProperties(
        properties => this.setState({ loading: false, properties }, () => typeof callback === 'function' && callback()),
        error => this.setState({ loading: false, error: true }, () => handleNetworkError(error))
    ));

    renderLoader = () => <div style={centerAbs}><CircularProgress /></div>;

    renderError = () => <div style={centerAbs}>
        <div style={this.gs('error_title')}>{this.gc('something_went_wrong')}</div>
        <div style={this.gs('error_desc')}>{this.gc('Click')} &nbsp;<div style={this.gs('error_action')} onClick={this.indexCall}>{this.gc('here')}</div>&nbsp;{this.gc('to_retry')}</div>
    </div>;

    renderEmptyView = () => <div style={columnCenter}>

        <div>
            {this.state.loading ? <Property style={this.gs('no_property')} /> : <NoProperty style={this.gs('no_property')} />}
            <LineLoader visible={this.state.loading} style={{ width: '100%' }} />

        </div>
        <Collapse in={this.state.loading} enter={false}>
            <div style={this.gs('empty_line_2')}>Fetching your Properties ...</div>
        </Collapse>
        <Collapse in={!this.state.loading} exit={false}><div style={columnCenter}>
            <div style={this.gs('empty_line_1')}>You haven’t added any property yet</div>
            <div style={this.gs('empty_line_2')}>Let us help you grow your business by reaching more audience.</div>
            
            <Link to={getRouteForPage(pages.PROPERTIES,'new')} style ={this.gs('add_wrapper_style')}>
            <ButtonBase style={this.gs('add_property')} onClick={this.onAdd}>
                <AddRounded style={this.gs('add_icon')} />{this.gc('add_a_property')}
            </ButtonBase>
            </Link>
        </div></Collapse>
    </div>;

    getCardWidthOverride = menu => {
        const menuWidth = this.getViewMode() === view.DESKTOP && menu ? MENU_WIDTH : 0;
        const minWidth = 248, margin = this.getViewMode() === view.DESKTOP ? 40 : 20;
        const containerWidth = this.getWidth() - 64 - menuWidth
        const cardsPerRow = Math.floor(containerWidth / (minWidth + margin));
        return this.getViewMode() === view.MOBILE ? {} : { width: (containerWidth / cardsPerRow) - margin - 1 };
    };

    renderContent = menu => <>
        <div style={this.gs('non_empty_container')}>
            <div style={this.gs('title')}>Your Properties ({this.state.properties.length})</div>
            <div style={this.gs('list')}>
                {this.state.properties.map((_, _i) => <OYOCard key={_i} data={_} style={merge(this.gs('card'), this.getCardWidthOverride(menu), { animationDelay: `${(_i + 1) * .25}s` })} className='animatesFadeUp' />)}
                <OyoAddCard style={merge(this.gs('card'), this.gs('add_card'), this.getCardWidthOverride(menu))} className='animatesFadeUp' gc={this.gc}/>
            </div>
        </div>
    </>;

    toggleCreateDialog = bool => () => this.setState({ createDialog: bool });

    renderCreateDialog = () => <Dialog maxWidth='md' open={this.state.createDialog} TransitionComponent={GrowTransition}
         onClose={this.toggleCreateDialog(false)} fullWidth style={{maxWidth: 890, margin: 'auto'}}>
        <Popup onClose={this.toggleCreateDialog(false)} gc={this.gc}/>
    </Dialog>;

    render = () => {
        const { loading, error, properties } = this.state;
        return <Page title={this.gc('my_properties')} contentStyle={{ position: 'relative' }} renderFooter={() => <CyclicFooter style={this.gs('footer')} />}>
            {({ menu }) => <>
                {isEmptyList(properties) && !error ? this.renderEmptyView() : null}
                {!isEmptyList(properties) ? this.renderContent(menu) : null}
                {!loading && error ? this.renderError() : null}
                {!isEmptyList(properties) && properties.length > 2 ? null :
                    <div style={this.gs('carousel')}><Carousel style={{ margin: '0px 0px 100px', transform: 'scale(0.8)' }} /></div>
                }
                
                {this.renderCreateDialog()}
            </>}
        </Page>;
    }

}

export default withTranslations(withResizer(PropertyListing));
